import { createFileRoute } from "@tanstack/react-router";
import TimitraMartin from "@/pages/TimitraMartin";
export const Route = createFileRoute("/timitra-martin")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Timitra Martin | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Meet Timitra Martin, a dedicated clinician at Neuro Wellness TMS in Coral Springs, FL providing compassionate depression and TMS care Free consultation.",
        },
        {
          property: "og:title",
          content: "Timitra Martin | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Meet Timitra Martin, a dedicated clinician at Neuro Wellness TMS in Coral Springs, FL providing compassionate depression and TMS care Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/timitra-martin",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/timitra-martin",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TimitraMartin />;
}
